import { Injectable } from '@angular/core';
import { Router, CanActivate, UrlTree } from '@angular/router';
import { SessionService } from '../session.service';

/**
 * Empêche l'accès aux pages « invité » (login) quand l'utilisateur est déjà
 * connecté : il est alors redirigé vers sa page d'accueil selon son rôle.
 */
@Injectable({
    providedIn: 'root'
})
export class GuestGuard implements CanActivate {
    constructor(
        private router: Router,
        private sessionService: SessionService
    ) {}

    canActivate(): boolean | UrlTree {
        if (!this.sessionService.isLoggedIn) {
            return true;
        }

        const destination = this.sessionService.hasRole('ROLE_ADMIN')
            ? '/dashboard/campagne'
            : '/dashboard/diplome-delivrance';
        return this.router.parseUrl(destination);
    }
}
